<mat-sidenav-container>
	<mat-sidenav #drawer fixedInViewport role="dialog" mode="over">
		<deedly-admin-drawer [drawerInput]="drawer" (drawerClosed)="drawer.close()"></deedly-admin-drawer>
	</mat-sidenav>
	<mat-sidenav-content>
		<deedly-admin-header [drawerInput]="drawer"></deedly-admin-header>
		<router-outlet></router-outlet>
	</mat-sidenav-content>
</mat-sidenav-container>
